<template>
  <div>
    <loading :active="loadingIsCompleted"></loading>
    <main-layout :active="7">
      <!-- Stats Cards -->
      <div class="col-xl-12">
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
            <div class="card text-center pt-2">
              <div class="card-body">
                <p class="mb-1">Total Afiliados</p>
                <h4>{{ stats.total_affiliates || 0 }}</h4>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
            <div class="card text-center pt-2">
              <div class="card-body">
                <p class="mb-1">Total Indicações</p>
                <h4>{{ stats.total_referrals || 0 }}</h4>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
            <div class="card text-center pt-2">
              <div class="card-body">
                <p class="mb-1">Comissões Pagas</p>
                <h4>R$ {{ Number(stats.total_commissions_paid || 0).toFixed(2) }}</h4>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
            <div class="card text-center pt-2">
              <div class="card-body">
                <p class="mb-1">Comissões Pendentes</p>
                <h4>R$ {{ Number(stats.pending_commissions || 0).toFixed(2) }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-header">
            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'list' }" @click="activeTab = 'list'" href="javascript:void(0)">
                  <i class="fa fa-users"></i> Afiliados
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'withdrawals' }" @click="activeTab = 'withdrawals'" href="javascript:void(0)">
                  <i class="fa fa-money"></i> Saques
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'create' }" @click="activeTab = 'create'" href="javascript:void(0)">
                  <i class="fa fa-plus"></i> Criar Afiliado
                </a>
              </li>
            </ul>
          </div>

          <div class="card-body">
            <!-- Tab: Lista de Afiliados -->
            <div v-if="activeTab === 'list'">
              <div class="row mb-3">
                <div class="col-md-6">
                  <input
                    type="text"
                    placeholder="Buscar por nome ou código"
                    class="form-control"
                    v-model="searchQuery"
                  />
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-striped mb-0">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Cliente</th>
                      <th>Código</th>
                      <th>Comissão</th>
                      <th>Desconto</th>
                      <th>Indicações</th>
                      <th>Total Ganho</th>
                      <th>Status</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="filteredAffiliates.length === 0">
                      <td colspan="9" class="text-center">
                        <h5>Nenhum afiliado encontrado</h5>
                      </td>
                    </tr>
                    <tr v-for="affiliate in filteredAffiliates" :key="affiliate.id">
                      <td>#{{ affiliate.id }}</td>
                      <td>
                        <strong>{{ affiliate.client_name }}</strong><br />
                        <small>{{ affiliate.client_whatsapp }}</small>
                      </td>
                      <td>
                        <span class="badge badge-primary">{{ affiliate.affiliate_code }}</span>
                      </td>
                      <td>R$ {{ parseFloat(affiliate.commission_value || 0).toFixed(2) }}</td>
                      <td>{{ parseFloat(affiliate.discount_percentage || 0) }}%</td>
                      <td>{{ affiliate.total_referrals }}</td>
                      <td>R$ {{ parseFloat(affiliate.total_commissions_earned || 0).toFixed(2) }}</td>
                      <td>
                        <span :class="affiliate.is_active ? 'badge badge-success' : 'badge badge-danger'">
                          {{ affiliate.is_active ? 'Ativo' : 'Inativo' }}
                        </span>
                      </td>
                      <td>
                        <button @click="editAffiliate(affiliate)" class="btn btn-sm btn-primary mr-1" title="Editar">
                          <i class="fa fa-pencil"></i>
                        </button>
                        <button @click="viewDetails(affiliate)" class="btn btn-sm btn-info mr-1" title="Ver Detalhes">
                          <i class="fa fa-eye"></i>
                        </button>
                        <button 
                          @click="toggleStatus(affiliate)" 
                          :class="affiliate.is_active ? 'btn btn-sm btn-warning' : 'btn btn-sm btn-success'"
                          title="Ativar/Desativar"
                        >
                          <i :class="affiliate.is_active ? 'fa fa-ban' : 'fa fa-check'"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Tab: Saques -->
            <div v-if="activeTab === 'withdrawals'">
              <div class="row mb-3">
                <div class="col-md-4">
                  <select class="form-control" v-model="withdrawalStatus" @change="loadWithdrawals">
                    <option value="pending">Pendentes</option>
                    <option value="approved">Aprovados</option>
                    <option value="rejected">Rejeitados</option>
                  </select>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-striped mb-0">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Afiliado</th>
                      <th>Código</th>
                      <th>Valor</th>
                      <th>Chave PIX</th>
                      <th>Tipo</th>
                      <th>Data</th>
                      <th>Status</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="withdrawals.length === 0">
                      <td colspan="9" class="text-center">
                        <h5>Nenhum saque encontrado</h5>
                      </td>
                    </tr>
                    <tr v-for="withdrawal in withdrawals" :key="withdrawal.id">
                      <td>#{{ withdrawal.id }}</td>
                      <td>
                        <strong>{{ withdrawal.client_name }}</strong><br />
                        <small>{{ withdrawal.client_whatsapp }}</small>
                      </td>
                      <td>
                        <span class="badge badge-primary">{{ withdrawal.affiliate_code }}</span>
                      </td>
                      <td>R$ {{ parseFloat(withdrawal.amount || 0).toFixed(2) }}</td>
                      <td>{{ withdrawal.pix_key }}</td>
                      <td>{{ withdrawal.pix_key_type.toUpperCase() }}</td>
                      <td>{{ formatDate(withdrawal.created_at) }}</td>
                      <td>
                        <span 
                          :class="{
                            'badge badge-warning': withdrawal.status === 'pending',
                            'badge badge-success': withdrawal.status === 'approved',
                            'badge badge-danger': withdrawal.status === 'rejected'
                          }"
                        >
                          {{ withdrawal.status === 'pending' ? 'Pendente' : withdrawal.status === 'approved' ? 'Aprovado' : 'Rejeitado' }}
                        </span>
                      </td>
                      <td>
                        <button 
                          v-if="withdrawal.status === 'pending'"
                          @click="approveWithdrawal(withdrawal)" 
                          class="btn btn-sm btn-success mr-1"
                          title="Aprovar"
                        >
                          <i class="fa fa-check"></i>
                        </button>
                        <button 
                          v-if="withdrawal.status === 'pending'"
                          @click="rejectWithdrawal(withdrawal)" 
                          class="btn btn-sm btn-danger"
                          title="Rejeitar"
                        >
                          <i class="fa fa-times"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Tab: Criar Afiliado -->
            <div v-if="activeTab === 'create'">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Cliente *</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Digite o ID do cliente"
                      v-model="newAffiliate.client_id"
                    />
                    <small class="form-text text-muted">
                      ID do cliente que será afiliado
                    </small>
                  </div>

                  <div class="form-group">
                    <label>Comissão por Venda (R$) *</label>
                    <input
                      type="number"
                      step="0.01"
                      class="form-control"
                      placeholder="7.00"
                      v-model="newAffiliate.commission_value"
                    />
                    <small class="form-text text-muted">
                      Valor fixo que o afiliado ganha por cada recorrência
                    </small>
                  </div>

                  <div class="form-group">
                    <label>Desconto do Cupom (%) *</label>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      class="form-control"
                      placeholder="0"
                      v-model="newAffiliate.discount_percentage"
                    />
                    <small class="form-text text-muted">
                      Desconto que o cupom do afiliado oferece (0-100%)
                    </small>
                  </div>

                  <button @click="createAffiliate" class="btn btn-primary btn-block">
                    <i class="fa fa-plus"></i> Criar Afiliado
                  </button>
                </div>

                <div class="col-md-6">
                  <div class="alert alert-info">
                    <h5><i class="fa fa-info-circle"></i> Como funciona:</h5>
                    <ul>
                      <li>O código de afiliado será gerado automaticamente</li>
                      <li>O afiliado ganhará a comissão definida a cada recorrência de pagamento</li>
                      <li>O cupom pode oferecer desconto para incentivar indicações</li>
                      <li>Comissões são creditadas automaticamente na carteira</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main-layout>

    <!-- Modal: Editar Afiliado -->
    <div v-if="showEditModal" class="modal fade show" style="display: block; background: rgba(0,0,0,0.5)">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Editar Afiliado</h5>
            <button type="button" class="close" @click="showEditModal = false">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Cliente</label>
              <input type="text" class="form-control" :value="editingAffiliate.client_name" disabled />
            </div>
            <div class="form-group">
              <label>Código de Afiliado</label>
              <input type="text" class="form-control" v-model="editingAffiliate.affiliate_code" />
            </div>
            <div class="form-group">
              <label>Comissão por Venda (R$)</label>
              <input type="number" step="0.01" class="form-control" v-model="editingAffiliate.commission_value" />
            </div>
            <div class="form-group">
              <label>Desconto do Cupom (%)</label>
              <input type="number" min="0" max="100" class="form-control" v-model="editingAffiliate.discount_percentage" />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showEditModal = false">Cancelar</button>
            <button type="button" class="btn btn-primary" @click="saveAffiliate">Salvar Alterações</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: Detalhes do Afiliado -->
    <div v-if="showDetailsModal" class="modal fade show" style="display: block; background: rgba(0,0,0,0.5)">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Detalhes do Afiliado</h5>
            <button type="button" class="close" @click="showDetailsModal = false">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <h6>Informações Básicas</h6>
                <p><strong>Cliente:</strong> {{ affiliateDetails.client_name }}</p>
                <p><strong>WhatsApp:</strong> {{ affiliateDetails.client_whatsapp }}</p>
                <p><strong>Código:</strong> <span class="badge badge-primary">{{ affiliateDetails.affiliate_code }}</span></p>
                <p><strong>Link:</strong> <a :href="'https://vidaon.fit/?ref=' + affiliateDetails.affiliate_code" target="_blank">
                  https://vidaon.fit/?ref={{ affiliateDetails.affiliate_code }}
                </a></p>
              </div>
              <div class="col-md-6">
                <h6>Configurações</h6>
                <p><strong>Comissão:</strong> R$ {{ parseFloat(affiliateDetails.commission_value || 0).toFixed(2) }}</p>
                <p><strong>Desconto:</strong> {{ parseFloat(affiliateDetails.discount_percentage || 0) }}%</p>
                <p><strong>Total Indicações:</strong> {{ affiliateDetails.total_referrals || 0 }}</p>
                <p><strong>Total Ganho:</strong> R$ {{ parseFloat(affiliateDetails.total_commissions_earned || 0).toFixed(2) }}</p>
              </div>
            </div>

            <hr />

            <h6>Últimas Comissões</h6>
            <div class="table-responsive">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>Mês</th>
                    <th>Valor</th>
                    <th>Status</th>
                    <th>Data</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!affiliateDetails.commissions || affiliateDetails.commissions.length === 0">
                    <td colspan="4" class="text-center">Nenhuma comissão ainda</td>
                  </tr>
                  <tr v-for="commission in (affiliateDetails.commissions || []).slice(0, 10)" :key="commission.id">
                    <td>{{ commission.month_ref }}</td>
                    <td>R$ {{ parseFloat(commission.amount || 0).toFixed(2) }}</td>
                    <td>
                      <span :class="{
                        'badge badge-warning': commission.status === 'pending',
                        'badge badge-success': commission.status === 'approved'
                      }">
                        {{ commission.status === 'pending' ? 'Pendente' : 'Aprovado' }}
                      </span>
                    </td>
                    <td>{{ formatDate(commission.created_at) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showDetailsModal = false">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainLayout from "../../components/Layouts/MainLayout.vue";
import Loading from "../../components/Layouts/Loading.vue";
import api from "../../services/funcoes-service";
import moment from "moment";

export default {
  components: { MainLayout, Loading },
  data() {
    return {
      loadingIsCompleted: true,
      activeTab: 'list',
      searchQuery: '',
      affiliates: [],
      withdrawals: [],
      withdrawalStatus: 'pending',
      stats: {
        total_affiliates: 0,
        total_referrals: 0,
        total_commissions_paid: 0,
        pending_commissions: 0
      },
      newAffiliate: {
        client_id: '',
        commission_value: 7.00,
        discount_percentage: 0
      },
      editingAffiliate: {},
      affiliateDetails: {},
      showEditModal: false,
      showDetailsModal: false
    };
  },
  computed: {
    filteredAffiliates() {
      if (!this.searchQuery) return this.affiliates;
      const query = this.searchQuery.toLowerCase();
      return this.affiliates.filter(a => 
        a.client_name.toLowerCase().includes(query) ||
        a.affiliate_code.toLowerCase().includes(query) ||
        a.client_whatsapp.includes(query)
      );
    }
  },
  async mounted() {
    await this.loadStats();
    await this.loadAffiliates();
    await this.loadWithdrawals();
  },
  methods: {
    formatDate(date) {
      return moment(date).utc().format("DD/MM/YYYY HH:mm");
    },

    async loadStats() {
      try {
        const response = await api.get('/admin/affiliates/stats');
        if (response.data.error === 0) {
          this.stats = response.data.stats;
        }
      } catch (error) {
        console.error('Erro ao carregar estatísticas:', error);
      }
    },

    async loadAffiliates() {
      try {
        this.loadingIsCompleted = true;
        const response = await api.get('/admin/affiliates?page=1&limit=100');
        if (response.data.error === 0) {
          this.affiliates = response.data.affiliates.data;
        }
        this.loadingIsCompleted = false;
      } catch (error) {
        this.loadingIsCompleted = false;
        this.$toast.error("Erro ao carregar afiliados!");
      }
    },

    async loadWithdrawals() {
      try {
        const response = await api.get(`/admin/affiliates/withdrawals?status=${this.withdrawalStatus}&page=1&limit=100`);
        if (response.data.error === 0) {
          this.withdrawals = response.data.withdrawals.data;
        }
      } catch (error) {
        this.$toast.error("Erro ao carregar saques!");
      }
    },

    async createAffiliate() {
      if (!this.newAffiliate.client_id) {
        this.$toast.error("Informe o ID do cliente!");
        return;
      }

      try {
        this.loadingIsCompleted = true;
        const response = await api.post('/admin/affiliates', this.newAffiliate);
        if (response.data.error === 0) {
          this.$toast.success("Afiliado criado com sucesso!");
          this.newAffiliate = { client_id: '', commission_value: 7.00, discount_percentage: 0 };
          this.activeTab = 'list';
          await this.loadAffiliates();
          await this.loadStats();
        } else {
          this.$toast.error(response.data.message || "Erro ao criar afiliado!");
        }
        this.loadingIsCompleted = false;
      } catch (error) {
        this.loadingIsCompleted = false;
        this.$toast.error(error.response?.data?.message || "Erro ao criar afiliado!");
      }
    },

    editAffiliate(affiliate) {
      this.editingAffiliate = { ...affiliate };
      this.showEditModal = true;
    },

    async saveAffiliate() {
      try {
        this.loadingIsCompleted = true;
        const response = await api.put(`/admin/affiliates/${this.editingAffiliate.id}`, {
          commission_value: this.editingAffiliate.commission_value,
          discount_percentage: this.editingAffiliate.discount_percentage,
          affiliate_code: this.editingAffiliate.affiliate_code
        });
        if (response.data.error === 0) {
          this.$toast.success("Afiliado atualizado com sucesso!");
          this.showEditModal = false;
          await this.loadAffiliates();
        } else {
          this.$toast.error(response.data.message || "Erro ao atualizar!");
        }
        this.loadingIsCompleted = false;
      } catch (error) {
        this.loadingIsCompleted = false;
        this.$toast.error("Erro ao atualizar afiliado!");
      }
    },

    async toggleStatus(affiliate) {
      const newStatus = !affiliate.is_active;
      const action = newStatus ? 'ativar' : 'desativar';
      
      if (!confirm(`Deseja realmente ${action} este afiliado?`)) return;

      try {
        this.loadingIsCompleted = true;
        const response = await api.put(`/admin/affiliates/${affiliate.id}`, {
          is_active: newStatus
        });
        if (response.data.error === 0) {
          this.$toast.success(`Afiliado ${newStatus ? 'ativado' : 'desativado'} com sucesso!`);
          await this.loadAffiliates();
        }
        this.loadingIsCompleted = false;
      } catch (error) {
        this.loadingIsCompleted = false;
        this.$toast.error("Erro ao alterar status!");
      }
    },

    async viewDetails(affiliate) {
      try {
        this.loadingIsCompleted = true;
        const response = await api.get(`/admin/affiliates/${affiliate.id}`);
        if (response.data.error === 0) {
          this.affiliateDetails = response.data.affiliate;
          this.affiliateDetails.commissions = response.data.commissions || [];
          this.showDetailsModal = true;
        }
        this.loadingIsCompleted = false;
      } catch (error) {
        this.loadingIsCompleted = false;
        this.$toast.error("Erro ao carregar detalhes!");
      }
    },

    async approveWithdrawal(withdrawal) {
      const notes = prompt("Observações (opcional - ex: PIX enviado em DD/MM/YYYY):");
      if (notes === null) return; // Cancelou

      try {
        this.loadingIsCompleted = true;
        const response = await api.post(`/admin/affiliates/withdrawals/${withdrawal.id}/approve`, {
          admin_notes: notes || 'Aprovado'
        });
        if (response.data.error === 0) {
          this.$toast.success("Saque aprovado com sucesso!");
          await this.loadWithdrawals();
          await this.loadStats();
        }
        this.loadingIsCompleted = false;
      } catch (error) {
        this.loadingIsCompleted = false;
        this.$toast.error("Erro ao aprovar saque!");
      }
    },

    async rejectWithdrawal(withdrawal) {
      const notes = prompt("Motivo da rejeição:");
      if (!notes) {
        this.$toast.error("Informe o motivo da rejeição!");
        return;
      }

      try {
        this.loadingIsCompleted = true;
        const response = await api.post(`/admin/affiliates/withdrawals/${withdrawal.id}/reject`, {
          admin_notes: notes
        });
        if (response.data.error === 0) {
          this.$toast.success("Saque rejeitado! Valor devolvido à carteira.");
          await this.loadWithdrawals();
        }
        this.loadingIsCompleted = false;
      } catch (error) {
        this.loadingIsCompleted = false;
        this.$toast.error("Erro ao rejeitar saque!");
      }
    }
  }
};
</script>

<style scoped>
.nav-tabs .nav-link {
  cursor: pointer;
}
.modal.show {
  z-index: 1050;
}
</style>
